import { Button, Row, Col, message, Spin, Grid } from 'antd';
import { Routes } from 'config/routes';
import { useGetDonorQuery } from 'gql/types';
import { useModal } from 'modules/common/hooks';
import LabworkCardList from 'modules/donor/components/LabworkCardList';
import LabworkTable from 'modules/donor/components/LabworkTable';
import RoutineTestModal from 'modules/donor/components/RoutineTestModal';
import { useDonorLabwork } from 'modules/donor/hooks/useDonorLabwork';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

const DonorLabwork: FC = () => {
  const { t } = useTranslation('donor.DonorLabwork');
  const routineTestModal = useModal();
  const params = useParams();
  const shortDonorId = params.id || '';
  const breakpoints = Grid.useBreakpoint();
  const isBreakpointsEmpty = Object.keys(breakpoints).length === 0;
  const navigate = useNavigate();

  const canUpdateLabwork =
    useCurrentUser().data?.permissions?.updateLabworkData || false;
  const donorQuery = useGetDonorQuery({
    variables: {
      input: {
        id: shortDonorId,
      },
    },
    onError: (err) => {
      message.error(err.message);
      if (err.message === 'Not Found') {
        navigate(Routes.NotFound);
        return;
      }

      navigate(Routes.IndividualDonors);
    },
  });

  const donorId = donorQuery.data?.getDonor.id;
  const labwork = useDonorLabwork(donorId);

  const isLoading = donorQuery.loading || labwork.isLoading;

  return (
    <Spin spinning={isLoading}>
      <Row gutter={[0, 10]}>
        {canUpdateLabwork && (
          <Col span={24}>
            <Button
              onClick={() => {
                routineTestModal.show();
              }}
            >
              {t('routineTest')}
            </Button>
          </Col>
        )}
        <Col span={24}>
          <RoutineTestModal {...routineTestModal.config} />
          {!isBreakpointsEmpty &&
            (breakpoints.md ? (
              <LabworkTable
                labworks={labwork.labworks}
                updateLabworkStatusHandler={labwork.updateLabworkStatusHandler}
                updateLabworkHandler={labwork.updateLabworkHandler}
                removeLabworkHandler={labwork.removeLabworkHandler}
                pagination={labwork.pagination}
                sort={labwork.sort}
              />
            ) : (
              <LabworkCardList
                labworks={labwork.labworks}
                updateLabworkStatusHandler={labwork.updateLabworkStatusHandler}
                updateLabworkHandler={labwork.updateLabworkHandler}
                pagination={labwork.pagination}
                sort={labwork.sort}
              />
            ))}
        </Col>
      </Row>
    </Spin>
  );
};
export default DonorLabwork;
